import { render, staticRenderFns } from "./LayoutAccountNav.vue?vue&type=template&id=23233966&scoped=true"
import script from "./LayoutAccountNav.vue?vue&type=script&lang=js"
export * from "./LayoutAccountNav.vue?vue&type=script&lang=js"
import style0 from "./LayoutAccountNav.vue?vue&type=style&index=0&id=23233966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23233966",
  null
  
)

export default component.exports